module.exports = __webpack_public_path__ + "static/media/textsecuritydisc.f703de43.woff";